import { keyframes } from '@emotion/react';
export var overlayEnter = keyframes({
    from: {
        opacity: 0,
    },
    to: {
        opacity: 1,
    },
});
export var overlayExit = keyframes({
    from: {
        opacity: 1,
    },
    to: {
        opacity: 0,
    },
});
